import React from 'react';
// Import your regular homepage components that work for business too
import { Header, Footer, DynamicSavings } from '../components/HomePage';
// Import the new BusinessHero component
import PrepaidHero from '../components/Segmentations/Prepaid_Persona/PrepaidHero';


function PrepaidHeroPage() {
  return (
    <>
      
      <PrepaidHero />
      {/* You can add business-specific sections here later, or reuse existing ones */}
      
      <Footer />
    </>
  );
}

export default PrepaidHeroPage;